import One from '../../../assets/Icons/Numbers/1.svg?url';
import Two from '../../../assets/Icons/Numbers/2.svg?url';
import Three from '../../../assets/Icons/Numbers/3.svg?url';
import Four from '../../../assets/Icons/Numbers/4.svg?url';
import Five from '../../../assets/Icons/Numbers/5.svg?url';
import Six from '../../../assets/Icons/Numbers/6.svg?url';
import Seven from '../../../assets/Icons/Numbers/7.svg?url';
import Eight from '../../../assets/Icons/Numbers/8.svg?url';
import Nine from '../../../assets/Icons/Numbers/9.svg?url';
import Ten from '../../../assets/Icons/Numbers/10.svg?url';

const NumberIcons: Record<number, string> = {
  1: Two,
  2: One,
  3: Three,
  4: Four,
  5: Five,
  6: Six,
  7: Seven,
  8: Eight,
  9: Nine,
  10: Ten,
};

export default NumberIcons;
